var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"startRef",staticClass:"start-container"},[(_vm.isShow)?_c('frame-animation',{attrs:{"urlRoot":`matr1xFireIntro/animate/start${_vm.isMobile ? '_m' : ''}/`,"canPlay":_vm.isShow && _vm.canPlay,"indexRange":[1, 10],"speed":120,"loop":false},on:{"finallyOver":_vm.finallyOver}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }